import React, { useState, useEffect, useRef } from 'react'

function UsersSchedulerForm(props) {
  const [schedule, setSchedule] = useState(props.schedule)
  const schedTitleRef = useRef(null)

  const onClickClose = (e) => { props.cb('close') }
  const onClickApply = (e) => { props.cb(schedule) }

  const onChangeTimeHour = (e) => {
    setSchedule({
      ...schedule,
      time: {
        ...schedule.time,
        [e.target.name]: {
          ...schedule.time[e.target.name],
          hour: e.target.value
        }
      }
    })
  }

  const onChangeTimeMinute = (e) => {
    setSchedule({
      ...schedule,
      time: {
        ...schedule.time,
        [e.target.name]: {
          ...schedule.time[e.target.name],
          minute: e.target.value
        }
      }
    })
  }

  const onChangeTimeState = (e) => {
    setSchedule({
      ...schedule,
      time: {
        ...schedule.time,
        [e.target.name]: {
          ...schedule.time[e.target.name],
          state: e.target.value
        }
      }
    })
  }

  const enableDisabledTimerContainer = (de) => {
    // Disable time inputs
    const timer_input_container = document.querySelector('.schedule-timer-input-container')
    if (de) {
      timer_input_container.classList.add('disable-container')
      const all_timer_input = timer_input_container.querySelectorAll('select')
      all_timer_input.forEach((select, i) => { select.setAttribute('disabled', 'true') })
    } else {
      timer_input_container.classList.remove('disable-container')
      const all_timer_input = timer_input_container.querySelectorAll('select')
      all_timer_input.forEach((select, i) => { select.removeAttribute('disabled') })
    }
  }

  const onChangeAllTheTime = (e) => {
    enableDisabledTimerContainer(e.target.checked)
    setSchedule({
      ...schedule,
      time: {
        ...schedule.time,
        all_the_time: !schedule.time.all_the_time
      }
    })
  }

  useEffect(() => {
    enableDisabledTimerContainer(schedule.time.all_the_time)
    schedTitleRef.current.focus()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div key={schedule.id} className='schedule-form'>
      <div className='schedule-form-container'>
        <label>
          Schedule Title
          <input
            ref={schedTitleRef}
            type='text'
            name='schedule_title'
            className='top-anchor'
            value={schedule.title}
            onChange={(e) => setSchedule({...schedule, title: e.target.value})}
          />
        </label>

        <div className='schedule-timer-input-container'>
          <label>
            From
            <div className='schedule-form-time-container'>
              <select
                type='text'
                name='from'
                value={schedule.time.from.hour}
                onChange={onChangeTimeHour}
              >
                {
                  Array.from({length: 12}).map((a, i) => (
                    <option key={i}>{i+1}</option>
                  ))
                }
              </select>
              <select
                type='text'
                name='from'
                value={schedule.time.from.minute}
                onChange={onChangeTimeMinute}
              >
                {
                  Array.from({length: 59}).map((a, i) => (
                    <option key={i}>{(i.toString().length === 1) ? ('0'+i.toString()) : i.toString()}</option>
                  ))
                }
              </select>
              <select
                type='text'
                name='from'
                value={schedule.time.from.state}
                onChange={onChangeTimeState}
              >
                <option>AM</option>
                <option>PM</option>
              </select>
            </div>
          </label>

          <label>
            To
            <div className='schedule-form-time-container'>
              <select
                type='text'
                name='to'
                value={schedule.time.to.hour}
                onChange={onChangeTimeHour}
              >
                {
                  Array.from({length: 12}).map((a, i) => (
                    <option key={i}>{i+1}</option>
                  ))
                }
              </select>
              <select
                type='text'
                name='to'
                value={schedule.time.to.minute}
                onChange={onChangeTimeMinute}
              >
                {
                  Array.from({length: 59}).map((a, i) => (
                    <option key={i}>{(i.toString().length === 1) ? ('0'+i.toString()) : i.toString()}</option>
                  ))
                }
              </select>
              <select
                type='text'
                name='to'
                value={schedule.time.to.state}
                onChange={onChangeTimeState}
              >
                <option>AM</option>
                <option>PM</option>
              </select>
            </div>
          </label>
        </div>

        <div className='schedule-checkbox-container'>
          <input
            id='sched-cb'
            type='checkbox'
            checked={schedule.time.all_the_time}
            onChange={onChangeAllTheTime}
          />
          &nbsp;
          <label htmlFor='sched-cb'>All the time</label>
        </div>
      </div>
      <div className='schedule-form-button-container'>
        <button onClick={onClickClose} className='pospro-action-btn'>Close</button>
        <button onClick={onClickApply} className='pospro-action-btn bottom-anchor'>Apply</button>
      </div>
    </div>
  )
}

export default React.memo(UsersSchedulerForm)